export default {
  eyebrow: 'Portal de partners',
  title: 'Comisiones de procesamiento',
  description:
    'Tú pagas las comisiones de Stripe de cada pago online. La comisión de procesamiento establecida aquí se cobra a tus restaurantes para cubrirlas, salvo que un restaurante tenga una tarifa propia.',
  card_title: 'Comisión de procesamiento predeterminada',
  hint: 'Porcentaje en %, más un importe fijo y un mínimo opcionales por pago. «Cualquier método de pago» se aplica cuando no existe una tarifa específica para el método. Un cambio se aplica a los pagos realizados después de guardarlo.',
  hint_single:
    'La comisión de procesamiento se aplica a todos los métodos de pago online que no tienen una tarifa propia. Un cambio se aplica a los pagos realizados después de guardarlo.',
  hidden_rates:
    'Algunos métodos de pago también tienen su propia tarifa, establecida por el soporte de tu plataforma. Esas se aplican en lugar de esta tarifa.',
  empty: {
    title: 'No hay comisión de procesamiento predeterminada',
    description:
      'Hasta que establezcas una, o confirmes que no cobras comisión de procesamiento a tus restaurantes, tus restaurantes en Stripe no pueden salir en vivo y los que ya lo están no reciben pagos online (el efectivo sigue funcionando).',
  },
  consent: {
    give: 'Pagamos nosotros las comisiones de Stripe (confirmar margen del 0 %)',
    given_title: 'Margen del 0 % confirmado',
    given:
      'Confirmado por {{name}} el {{date}}: a los restaurantes sin tarifa propia no se les cobra comisión de procesamiento y tú pagas las comisiones de Stripe de sus pagos.',
    unknown_manager: 'un antiguo gestor',
    withdraw: 'Retirar',
    withdraw_confirm: {
      title: '¿Retirar la confirmación del margen del 0 %?',
      description:
        'Los restaurantes sin una tarifa propia no podrán activarse, y los que ya estén activos dejarán de aceptar pagos online hasta que establezcas una tarifa o vuelvas a confirmar.',
    },
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'No se pudieron cargar tus comisiones de procesamiento.',
    failed_to_save_changes: 'No se pudieron guardar tus comisiones de procesamiento.',
    changes_got_saved: 'Comisiones de procesamiento guardadas',
    consent_given: 'Margen del 0 % confirmado',
    consent_withdrawn: 'Confirmación retirada',
  },
};
